import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=0d90efc8&scoped=true&"
import script from "./UserItem.vue?vue&type=script&lang=js&"
export * from "./UserItem.vue?vue&type=script&lang=js&"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=0d90efc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d90efc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d90efc8')) {
      api.createRecord('0d90efc8', component.options)
    } else {
      api.reload('0d90efc8', component.options)
    }
    module.hot.accept("./UserItem.vue?vue&type=template&id=0d90efc8&scoped=true&", function () {
      api.rerender('0d90efc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/UserItem.vue"
export default component.exports